import React from 'react';
import { Button } from '@/components/ui';
import { PageHeader } from '@/components/ui/PageHeader/PageHeader';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function PageHeadersSection() {
  return (
    <SectionWrapper title="Page Headers">
        <div>
          <h3 className="text-lg font-semibold mb-4">Responsive Page Headers</h3>
          <div className="space-y-6">
            {/* Simple header */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <PageHeader title="Page Title" />
            </div>

            {/* Header with description */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <PageHeader
                title="Page with Description"
                description="This is a helpful description that explains what this page is about"
              />
            </div>

            {/* Header with single action */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <PageHeader
                title="Page with Single Action"
                description="Mobile-first responsive layout with one primary action"
              >
                <Button size="sm">Primary Action</Button>
              </PageHeader>
            </div>

            {/* Header with multiple actions */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <PageHeader
                title="Page with Multiple Actions"
                description="Actions stack vertically on mobile, horizontally on desktop"
              >
                <>
                  <Button variant="ghost" size="sm">Back</Button>
                  <Button variant="outline" size="sm">Secondary</Button>
                  <Button size="sm">Primary Action</Button>
                </>
              </PageHeader>
            </div>

            {/* Header with long title (truncation demo) */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <PageHeader
                title="Very Long Page Title That Would Overflow on Mobile Without Proper Handling"
                description="Title truncates with ellipsis on mobile, grows on larger screens"
              >
                <>
                  <Button variant="outline" size="sm">Action 1</Button>
                  <Button size="sm">Action 2</Button>
                </>
              </PageHeader>
            </div>
          </div>
          <CodeBlock>
{`// Simple header
<PageHeader title="Page Title" />

// Header with description
<PageHeader
  title="Page with Description"
  description="Helpful description text"
/>

// Single action (mobile-first responsive)
<PageHeader title="Page Title" description="Description">
  <Button size="sm">Primary Action</Button>
</PageHeader>

// Multiple actions (stacks on mobile, horizontal on desktop)
<PageHeader title="Page Title" description="Description">
  <>
    <Button variant="ghost" size="sm">Back</Button>
    <Button variant="outline" size="sm">Secondary</Button>
    <Button size="sm">Primary Action</Button>
  </>
</PageHeader>

// Key features:
// - Mobile-first: actions stack vertically on small screens
// - Desktop: actions display horizontally with proper spacing
// - Long titles truncate with ellipsis on mobile
// - Responsive typography scaling (text-2xl -> text-3xl)`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
